module.exports = __webpack_public_path__ + "img/person-3.9e842a80.png";